import React from 'react';
import ReactDOM from 'react-dom/client';
import Layout from './Layout';

document.title = "Anime Search | By Umikami";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Layout />
);